import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../Redux/Slices/adminPortalSlice';
import './Charts.css';



const options = {
    responsive: true,
    maintainAspectRatio: false,

    indexAxis: 'y',
    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    scales: {
        x: {  // not 'yAxes: [{' anymore (not an array anymore)
            ticks: {
                // color: "green", // not 'fontColor:' anymore
                // fontSize: 18,
                font: {
                    size: 20, // 'size' now within object 'font {}'
                },
                stepSize: 25,
                beginAtZero: true,
                callback: function (value) {
                    return (value)+'%'; // convert it to percentage
                },
                gridLines: {
                    display: false
                }
            }
        },
        y: {
            grid: { display: false },
            ticks: {
                // color: "green", // not 'fontColor:' anymore
                // fontSize: 18,
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                font: {
                    size: '18%', // 'size' now within object 'font {}'

                },
                stepSize: 1,
                beginAtZero: true
            }
        },
    },
    elements: {
        bar: {
            borderWidth: 2,
        },
    },
    responsive: true,
    plugins: {
        tooltip: {
            displayColors: false,
            intersect: false,
            callbacks: {
                label: function (context) {
                    return `Referrers: ${(context.dataset.data[context.dataIndex]).toFixed(2)}%`;
                },
            }
        },
        legend: {
            display: false,
            labels: {
                font: {
                    size: 20,
                    color: 'red',
                },
            }
        },
        title: {
            display: true,
            text: 'Traffic Sources',
            font: {
                size: 20,
            },
        },
    },
};

const HorizontalBarChart = () => {
    let fetchedData = useSelector(analysisData);

    return (
        <div className='HorizontalBar_Div'>
            {/* <h1 className='title'>Horizontal Bar Chart</h1> */}
            <Bar className='HorizontalBar' data={get_data(fetchedData.referrer)} options={options} />
        </div>
    );
}

export default HorizontalBarChart;



function get_data(referrer) {
    let totalReferrer = referrer.facebook + referrer.twitter + referrer.instagram + referrer.ccpweb + referrer.link_other;
    let facebookReferrer = (referrer.facebook / totalReferrer) * 100;
    let twitterReferrer = (referrer.twitter / totalReferrer) * 100;
    let instagramReferrer = (referrer.instagram / totalReferrer) * 100;
    let ccpwebReferrer = (referrer.ccpweb / totalReferrer) * 100;
    let link_otherReferrer = (referrer.link_other / totalReferrer) * 100;

    const data = {
        labels: ['Facebook', 'Twitter', 'Instagram', 'ccp-website', 'web-link + others '],
        datasets: [
            {
                label: 'referrer %',
                data: [facebookReferrer, twitterReferrer, instagramReferrer, ccpwebReferrer, link_otherReferrer],
                backgroundColor: [
                    'rgba(54, 162, 235, 0.2)',  
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                ],
                borderColor: [             
                    'rgba(54, 162, 235, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(255, 99, 132, 1)',
                    'rgba(153, 102, 255, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (data);
}